import React from 'react'
import CartItems from '../Components/CartItems/CartItems'


const Cart = () => {
  return (
    <CartItems/>
  )
}

export default Cart